export const Fonts = {
    Application: {
        Primary: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI",' +
            ' -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    },
};
